/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1649
 */

require(/* 86 */"./1650/86/index")({
  target: "Number",
  stat: true
}, {
  EPSILON: Math.pow(2, -52)
})
